module.exports = __webpack_public_path__ + "static/images/upload.23pamJY.svg";